var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCoolDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6895_19627",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(-90 0 24)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6895_19627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 12L15 19L13.575 17.6L18.175 13L11 13L11 11L18.175 11L13.6 6.4L15 5L22 12ZM9 13L6 13L6 11L9 11L9 13ZM4 13L2 13L2 11L4 11L4 13Z",
    fill: "#A1A1AA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCoolDown);
export default __webpack_public_path__ + "static/media/arrow_cool_down.651d2c7e8c7f46b18c45d6b5d61a021a.svg";
export { ForwardRef as ReactComponent };